import React from 'react';

const InputForm = (props)=>{
    return (
        <input 
            name={props.id}
            id={props.id}
            type={props.type}
            className={"form-control hour-input "+props.class}
            disabled={props.disabled}
            value={props.value} 
            onChange={(e)=>props.handleChange(e, props.variables)} 
            required={props.required}
            min={props.min}
            maxLength={props.maxLength}
            style={props.styles}
        />
    )
}

export default InputForm;

InputForm.defaultProps = {
    disabled:false,
    required:false,
    type:'text',
    maxLength:'',
    class:'',
    min:0,
    variables:null,
    styles:{}
}